module.exports = __webpack_public_path__ + "static/media/Vasudha.06b1bedd.jpeg";